/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import { TenantDetails, AuditRequestReason } from 'app/page-modules/tenant-management/models';

// -------------------------------------------------------------------------
// User Login
export const USER_LOGOUT = '[User Auth] User Logout';

// -------------------------------------------------------------------------
export const AUDITED_LOGIN_TO_TENANT = '[User Auth] Audited Login To Tenant';
export const AUDITED_LOGIN_TO_TENANT_ERROR = '[User Auth] Audited Login To Tenant Error';
export const LOGIN_TO_TENANT = '[User Auth] Login To Tenant';
export const LOGIN_TO_TENANT_SUCCESS = '[User Auth] Login To Tenant Success';
export const LOGIN_TO_TENANT_ERROR = '[User Auth] Login To Tenant Error';

// -------------------------------------------------------------------------
// User Logout
export class UserLogout implements Action {
  readonly type = USER_LOGOUT;
}

// -------------------------------------------------------------------------
// Login to tenant after providing a reason
export class AuditedLoginToTenant implements Action {
  readonly type = AUDITED_LOGIN_TO_TENANT;

  constructor(
    public tenantDetails: TenantDetails,
    public previewEnvironment: string | undefined,
    public auditDetails: AuditRequestReason
  ) {}
}

export class AuditedLoginToTenantError implements Action {
  readonly type = AUDITED_LOGIN_TO_TENANT_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
// Login to tenant
export class LoginToTenant implements Action {
  readonly type = LOGIN_TO_TENANT;

  constructor(public tenantDetails: TenantDetails, public previewEnvironment?: string) {}
}

/* Successfully logged in to tenant. */
export class LoginToTenantSuccess implements Action {
  readonly type = LOGIN_TO_TENANT_SUCCESS;

  constructor(public tenantDetails: TenantDetails) {}
}

/* Error occurred when logging in to tenant. */
export class LoginToTenantError implements Action {
  readonly type = LOGIN_TO_TENANT_ERROR;

  constructor(public errorMessage: string) {}
}

// -------------------------------------------------------------------------
export type All =
  | UserLogout
  | AuditedLoginToTenant
  | AuditedLoginToTenantError
  | LoginToTenant
  | LoginToTenantSuccess
  | LoginToTenantError;
